import { Package } from 'lucide-react';
import { withRBAC } from '../rbac';
import { InventoryCreate } from './InventoryCreate';
import { InventoryEdit } from './InventoryEdit';
import { InventoryList } from './InventoryList';
import { InventoryShow } from './InventoryShow';

export const inventory_items = {
    list: withRBAC(InventoryList, "view_all_data"),       // Using a generic view permission or custom
    show: withRBAC(InventoryShow, "view_all_data"),
    create: withRBAC(InventoryCreate, "manage_documents"), // Assuming manage_documents covers inventory as per old spec
    edit: withRBAC(InventoryEdit, "manage_documents"),
    icon: Package,
    recordRepresentation: 'name',
};

// Exporting transactions separately just in case
export const inventory_transactions = {
    recordRepresentation: (record: any) => `${record.transaction_type} ${record.quantity}`,
};
